import { QueryClient } from '@tanstack/react-query'

/**
 * Live authorization state. Declared here rather than in the hook so that
 * `api/client.ts` can invalidate it on 401/403 without an import cycle.
 */
export const AUTHZ_KEY = ['auth', 'authz'] as const

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
